import { render, staticRenderFns } from "./MobileCerveza.vue?vue&type=template&id=e8830004&scoped=true"
import script from "./MobileCerveza.vue?vue&type=script&lang=js"
export * from "./MobileCerveza.vue?vue&type=script&lang=js"
import style0 from "./MobileCerveza.vue?vue&type=style&index=0&id=e8830004&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8830004",
  null
  
)

export default component.exports